import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Punchcard from './punchcard';
import Rewards from './rewards';
import CustomerBalances from "@/common/customer-balances";
import BalanceViewer from "@/common/customer-balances/BalanceViewer";

const { Customer, UI } = Mobi2Go;

const LoyaltyModal = ({ closeModal, cardStatus }) => {
    const [t] = useTranslation('order.loyalty');
    const [creditBalance, setCreditBalance] = useState(0.0);
    const [loyalty, setLoyalty] = useState({});

    useEffect(() => {
        const updateState = () => {
            setCreditBalance(
                Customer.isLoggedIn() ? Customer.getCreditBalance() : null
            );
            setLoyalty(
                Customer.isLoggedIn()
                    ? Customer.getLoyalty('DataCandyLoyalty')
                    : null
            );
        };
        Customer.bind({
            logIn: updateState,
            logOut: updateState,
            updateLoyalty: updateState,
            updateCreditBalance: updateState,
        });
        updateState();
        return () => {
            Customer.unbind({
                logIn: updateState,
                logOut: updateState,
                updateLoyalty: updateState,
                updateCreditBalance: updateState,
            });
        };
    }, []);

    if (!Customer.isLoggedIn() || !loyalty) {
        return null;
    }

    const handleSetUp = () => {
        closeModal();
        UI.trigger('showCustomerDetails');
    };

    const className = name =>
        `m2g-customer-loyalty-datacandy-modal${name || ''}`;

    const incomplete_card_status = 'incomplete';

    return (
        <>
            {cardStatus === incomplete_card_status && (
                <div>
                    <div className={className('-set-up')}>
                        {t('set_up_loyalty')}
                    </div>
                    <button
                        className={className(
                            '-setup-button m2g-button m2g-button--primary'
                        )}
                        onClick={handleSetUp}
                    >
                        {t('set_up_button')}
                    </button>
                </div>
            )}

            < CustomerBalances
                ViewComponent={BalanceViewer}
            />

            <div className={className('-credit')}>
                {t('common:price', { price: creditBalance })}
            </div>
            <div className={className('-credit-label')}>
                {t('data_candy_credit_label')}
            </div>
            {loyalty?.state?.punch_card_progress && (
                <>
                    <h2 className={className('-punch-card-header')}>
                        {t('punch_cards')}
                    </h2>
                    <hr className={className('-line-break')} />
                    {loyalty?.state?.punch_card_progress?.map(punchcard => {
                        return (
                            <Punchcard
                                key={punchcard.drs_id}
                                title={punchcard.rule_name}
                                description={punchcard.rule_description}
                                num_punches_needed={punchcard.threshold}
                                punches={punchcard.value}
                            />
                        );
                    })}
                </>
            )}
            <Rewards cardStatus={cardStatus} closeModal={closeModal} />
        </>
    );
};

export default LoyaltyModal;
